const managementTableConfig = {
    1: [
        {
            label: '票据种类',
            selected: true,
            default: true,
            fieldName: 'invoiceType',
            type: 'dict',
            dict: 'ivat_inv_type',
        },
        {
            label: '发票代码',
            selected: true,
            default: true,
            fieldName: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '数电票号码',
            selected: false,
            default: false,
            fieldName: 'electricInvoiceNum',
        },
        {
            label: '开票日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '销方名称',
            selected: true,
            default: true,
            fieldName: 'saleName',
        },
        {
            label: '销方税号',
            selected: false,
            default: false,
            fieldName: 'saleCreditCode',
        },
        {
            label: '销方地址电话',
            selected: false,
            default: false,
            fieldName: 'saleAddressPhone',
        },
        {
            label: '销方银行账号',
            selected: false,
            default: false,
            fieldName: 'saleBankAccount',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'totalAmt',
        },
        {
            label: '税率',
            selected: false,
            default: false,
            fieldName: 'taxRate',
            type: 'dict',
            dict: 'ovat_tax_rate',
        },
        {
            label: '税额',
            selected: true,
            default: true,
            fieldName: 'totalTaxamt',
        },
        {
            label: '价税合计',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
        },
        {
            //13
            label: '购方名称',
            selected: false,
            default: false,
            fieldName: 'custName',
        },
        {
            //14
            label: '购方税号',
            selected: false,
            default: false,
            fieldName: 'custCreditCode',
        },
        {
            //15
            label: '购方地址电话',
            selected: false,
            default: false,
            fieldName: 'custAddressPhone',
        },
        {
            //16
            label: '购方银行账号',
            selected: false,
            default: false,
            fieldName: 'custBankAccount',
        },
        {
            //17
            label: '校验码',
            selected: false,
            default: false,
            fieldName: 'checkCode',
        },
        {
            //18
            label: '备注',
            selected: false,
            default: false,
            fieldName: 'remark',
        },
        {
            //19
            label: '发票状态',
            selected: true,
            default: true,
            fieldName: 'invoiceStatus',
            type: 'dict',
            dict: 'ivat_invoice_status',
        },
        {
            //20
            label: '收票状态',
            selected: false,
            default: false,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            //21
            label: '抵扣属期',
            selected: true,
            default: true,
            fieldName: 'dkssq',
        },
        {
            //22
            label: '转出属期',
            selected: false,
            default: false,
            fieldName: 'zcssq',
        },
        {
            //23
            label: '转出类型',
            selected: false,
            default: false,
            fieldName: 'turnOutType',
            type: 'dict',
            dict: 'ivatRuleList',
        },
        {
            //24
            label: '客运标志',
            selected: false,
            default: false,
            fieldName: 'passengerFlag',
            type: 'dict',
            dict: 'ivat_common_flag',
        },
        {
            //25
            label: '业务单据号',
            selected: false,
            default: false,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //28
            label: '录入方式',
            selected: false,
            default: false,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            label: '人员/录入时间',
            selected: false,
            default: false,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: false,
            default: false,
            fieldName: ['collectionPerson', 'collectionDate'],
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            // 46
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '税局入账用途',
            selected: false,
            default: false,
            fieldName: 'entryPurposeStatus',
            type: 'dict',
            dict: 'entry_purpose_status',
        },
        {
            label: '税局入账日期',
            selected: false,
            default: false,
            fieldName: 'entryDate',
        },
        {
            label: '入账失败原因',
            selected: false,
            default: false,
            fieldName: 'entryFailDesc',
        },
        {
            label: '状态比对',
            selected: false,
            default: false,
            fieldName: 'comparisonStatus',
            type: 'dict',
            dict: 'ivat_comparison_status',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 通用机打发票 2
    2: [
        {
            label: '发票代码',
            selected: true,
            default: true,
            fieldName: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
        },
        {
            label: '行业分类',
            selected: true,
            default: true,
            fieldName: 'industryCategory',
        },
        {
            label: '品名',
            selected: true,
            default: true,
            fieldName: 'productName',
        },
        {
            label: '收票状态',
            selected: true,
            default: true,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '业务单据号',
            selected: true,
            default: true,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: true,
            default: true,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: true,
            default: true,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: true,
            default: true,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 航空运输电子客票行程单 3
    3: [
        {
            label: '印刷序号',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '姓名',
            selected: true,
            default: true,
            fieldName: 'userName',
        },
        {
            label: '身份证件号码',
            selected: false,
            default: false,
            fieldName: 'idNumber',
        },
        {
            label: '行程日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '出发地',
            selected: true,
            default: true,
            fieldName: 'departure',
        },
        {
            label: '目的地',
            selected: true,
            default: true,
            fieldName: 'destination',
        },
        {
            //5
            label: '票价',
            selected: true,
            default: true,
            fieldName: 'ticketPrice',
            type: 'money',
        },
        {
            //6
            label: '民航发展基金',
            selected: false,
            default: false,
            fieldName: 'constructionFee',
            type: 'money',
        },
        {
            label: '燃油附加费',
            selected: true,
            default: true,
            fieldName: 'fuelSurcharge',
            type: 'money',
        },
        {
            //8
            label: '其他税费',
            selected: false,
            default: false,
            fieldName: 'otherTaxes',
            type: 'money',
        },
        {
            label: '合计金额',
            selected: true,
            default: true,
            fieldName: 'totalSum',
            type: 'money',
        },
        {
            //10
            label: '税率',
            selected: false,
            default: false,
            fieldName: 'taxRate',
            type: 'dict',
            dict: 'ovat_tax_rate',
        },
        {
            label: '税额',
            selected: true,
            default: true,
            fieldName: 'totalTaxamt',
            type: 'money',
        },
        {
            label: '电子客票号码',
            selected: false,
            default: false,
            fieldName: 'eTicket',
        },
        {
            label: '收票状态',
            selected: false,
            default: false,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '抵扣属期',
            selected: true,
            default: true,
            fieldName: 'dkssq',
        },
        {
            label: '转出属期',
            selected: false,
            default: false,
            fieldName: 'zcssq',
        },
        {
            label: '转出类型',
            selected: false,
            default: false,
            fieldName: 'turnOutType',
            type: 'dict',
            dict: 'ivatRuleList',
        },
        {
            label: '客运标志',
            selected: false,
            default: false,
            fieldName: 'passengerFlag',
            type: 'dict',
            dict: 'ivat_common_flag',
        },
        {
            label: '业务单据号',
            selected: false,
            default: false,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: false,
            default: false,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: false,
            default: false,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: false,
            default: false,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
            type: 'money',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 铁路车票
    4: [
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '姓名',
            selected: true,
            default: true,
            fieldName: 'userName',
        },
        {
            label: '身份证件号码',
            selected: false,
            default: false,
            fieldName: 'idNumber',
        },
        {
            label: '日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '出发地',
            selected: true,
            default: true,
            fieldName: 'departure',
        },
        {
            label: '目的地',
            selected: true,
            default: true,
            fieldName: 'destination',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
            type: 'money',
        },
        {
            label: '税率',
            selected: false,
            default: false,
            fieldName: 'taxRate',
            type: 'dict',
            dict: 'ovat_tax_rate',
        },
        {
            label: '税额',
            selected: true,
            default: true,
            fieldName: 'totalTaxamt',
            type: 'money',
        },
        {
            label: '收票状态',
            selected: false,
            default: false,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '抵扣属期',
            selected: true,
            default: true,
            fieldName: 'dkssq',
        },
        {
            label: '转出属期',
            selected: false,
            default: false,
            fieldName: 'zcssq',
        },
        {
            label: '转出类型',
            selected: false,
            default: false,
            fieldName: 'turnOutType',
            type: 'dict',
            dict: 'ivatRuleList',
        },
        {
            label: '客运标志',
            selected: false,
            default: false,
            fieldName: 'passengerFlag',
            type: 'dict',
            dict: 'ivat_common_flag',
        },
        {
            label: '业务单据号',
            selected: false,
            default: false,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //18
            label: '录入方式',
            selected: false,
            default: false,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //19
            label: '人员/录入时间',
            selected: false,
            default: false,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: false,
            default: false,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '座席',
            selected: false,
            default: false,
            fieldName: 'seatType',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 公路、水路发票
    5: [
        {
            label: '发票代码',
            selected: true,
            default: true,
            fieldName: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '姓名',
            selected: true,
            default: true,
            fieldName: 'userName',
        },
        {
            label: '身份证件号码',
            selected: false,
            default: false,
            fieldName: 'idNumber',
        },
        {
            label: '日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '出发地',
            selected: true,
            default: true,
            fieldName: 'departure',
        },
        {
            label: '目的地',
            selected: true,
            default: true,
            fieldName: 'destination',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
            type: 'money',
        },
        {
            label: '税率',
            selected: false,
            default: false,
            fieldName: 'taxRate',
            type: 'dict',
            dict: 'ovat_tax_rate',
        },
        {
            label: '税额',
            selected: true,
            default: true,
            fieldName: 'totalTaxamt',
            type: 'money',
        },
        {
            label: '收票状态',
            selected: false,
            default: false,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '抵扣属期',
            selected: true,
            default: true,
            fieldName: 'dkssq',
        },
        {
            label: '转出属期',
            selected: false,
            default: false,
            fieldName: 'zcssq',
        },
        {
            label: '转出类型',
            selected: false,
            default: false,
            fieldName: 'turnOutType',
            type: 'dict',
            dict: 'ivatRuleList',
        },
        {
            label: '客运标志',
            selected: false,
            default: false,
            fieldName: 'passengerFlag',
            type: 'dict',
            dict: 'ivat_common_flag',
        },
        {
            label: '业务单据号',
            selected: false,
            default: false,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //18
            label: '录入方式',
            selected: false,
            default: false,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //19
            label: '人员/录入时间',
            selected: false,
            default: false,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: false,
            default: false,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 出租车发票 6
    6: [
        {
            label: '发票代码',
            selected: true,
            default: true,
            fieldName: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
            type: 'money',
        },
        {
            label: '出发地',
            selected: true,
            default: true,
            fieldName: 'departure',
        },
        {
            label: '目的地',
            selected: true,
            default: true,
            fieldName: 'destination',
        },
        {
            label: '上车时间',
            selected: true,
            default: true,
            fieldName: 'getTime',
        },
        {
            label: '下车时间',
            selected: true,
            default: true,
            fieldName: 'offTime',
        },
        {
            label: '收票状态',
            selected: true,
            default: true,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '业务单据号',
            selected: true,
            default: true,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: true,
            default: true,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: true,
            default: true,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: true,
            default: true,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '车号',
            selected: false,
            default: false,
            fieldName: 'plateNum',
        },
        {
            label: '里程',
            selected: false,
            default: false,
            fieldName: 'mileage',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 过桥、路费发票 7
    7: [
        {
            label: '发票代码',
            selected: true,
            default: true,
            fieldName: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '开票日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
            type: 'money',
        },
        {
            label: '入口',
            selected: true,
            default: true,
            fieldName: 'entrance',
        },
        {
            label: '出口',
            selected: true,
            default: true,
            fieldName: 'exit',
        },
        {
            label: '车型',
            selected: true,
            default: true,
            fieldName: 'vehicleType',
        },
        {
            label: '收票状态',
            selected: true,
            default: true,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '业务单据号',
            selected: true,
            default: true,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: true,
            default: true,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: true,
            default: true,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: true,
            default: true,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 通用定额发票 8
    8: [
        {
            label: '发票代码',
            selected: true,
            default: true,
            fieldName: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'oneAmount',
        },
        {
            label: '份数',
            selected: true,
            default: true,
            fieldName: 'number',
        },
        {
            label: '总额',
            selected: true,
            default: true,
            fieldName: 'totalSum',
        },
        {
            label: '收票状态',
            selected: true,
            default: true,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '业务单据号',
            selected: true,
            default: true,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: true,
            default: true,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: true,
            default: true,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: true,
            default: true,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 停车费发票 9
    9: [
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
        },
        {
            label: '开始时间',
            selected: true,
            default: true,
            fieldName: 'getTime',
        },
        {
            label: '结束时间',
            selected: true,
            default: true,
            fieldName: 'offTime',
        },
        {
            label: '车牌号',
            selected: true,
            default: true,
            fieldName: 'plateNumber',
        },
        {
            label: '收票状态',
            selected: true,
            default: true,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '业务单据号',
            selected: true,
            default: true,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: true,
            default: true,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: true,
            default: true,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: true,
            default: true,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 机动车10
    10: [
        {
            //1
            label: '发票代码',
            selected: true,
            default: true,
            fieldName: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '开票日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '销方单位名称',
            selected: true,
            default: true,
            fieldName: 'saleName',
        },
        {
            //5
            label: '销方税号',
            selected: false,
            default: false,
            fieldName: 'saleCreditCode',
        },
        {
            //6
            label: '销方地址',
            selected: false,
            default: false,
            fieldName: 'saleAddress',
        },
        {
            //7
            label: '销方电话',
            selected: false,
            default: false,
            fieldName: 'salePhone',
        },
        {
            //8
            label: '销方开户银行',
            selected: false,
            default: false,
            fieldName: 'saleBank',
        },
        {
            //9
            label: '销方账号',
            selected: false,
            default: false,
            fieldName: 'saleBankAccount',
        },
        {
            //10
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'totalAmt',
        },
        {
            label: '税率',
            selected: false,
            default: false,
            fieldName: 'taxRate',
            type: 'dict',
            dict: 'ovat_tax_rate',
        },
        {
            label: '税额',
            selected: true,
            default: true,
            fieldName: 'totalTaxamt',
        },
        {
            label: '价税合计',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
        },
        {
            label: '购方名称',
            selected: false,
            default: false,
            fieldName: 'custName',
        },
        {
            //15
            label: '购方税号',
            selected: false,
            default: false,
            fieldName: 'custCreditCode',
        },
        {
            label: '完税凭证号码',
            selected: false,
            default: false,
            fieldName: 'proofNumber',
        },
        {
            label: '发票状态',
            selected: true,
            default: true,
            fieldName: 'invoiceStatus',
            type: 'dict',
            dict: 'ivat_invoice_status',
        },
        {
            label: '收票状态',
            selected: false,
            default: false,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            //20
            label: '抵扣属期',
            selected: true,
            default: true,
            fieldName: 'dkssq',
        },
        {
            label: '转出属期',
            selected: false,
            default: false,
            fieldName: 'zcssq',
        },
        {
            label: '转出类型',
            selected: false,
            default: false,
            fieldName: 'turnOutType',
            type: 'dict',
            dict: 'ivatRuleList',
        },
        {
            label: '业务单据号',
            selected: false,
            default: false,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: false,
            default: false,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: false,
            default: false,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: false,
            default: false,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 二手车销售统一发票 11
    11: [
        {
            //1
            label: '发票代码',
            selected: true,
            default: true,
            fieldName: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '开票日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '销方单位名称',
            selected: true,
            default: true,
            fieldName: 'saleName',
        },
        {
            //5
            label: '销方税号',
            selected: false,
            default: false,
            fieldName: 'saleCreditCode',
        },
        {
            //6
            label: '销方地址',
            selected: false,
            default: false,
            fieldName: 'saleAddress',
        },
        {
            //7
            label: '销方电话',
            selected: false,
            default: false,
            fieldName: 'salePhone',
        },
        {
            //8
            label: '销方开户银行',
            selected: false,
            default: false,
            fieldName: 'saleBank',
        },
        {
            //9
            label: '销方账号',
            selected: false,
            default: false,
            fieldName: 'saleBankAccount',
        },
        {
            //10
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'totalAmt',
        },
        {
            label: '税率',
            selected: false,
            default: false,
            fieldName: 'taxRate',
            type: 'dict',
            dict: 'ovat_tax_rate',
        },
        {
            label: '税额',
            selected: true,
            default: true,
            fieldName: 'totalTaxamt',
        },
        {
            label: '价税合计',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
        },
        {
            label: '购方名称',
            selected: false,
            default: false,
            fieldName: 'custName',
        },
        {
            //15
            label: '购方税号',
            selected: false,
            default: false,
            fieldName: 'custCreditCode',
        },
        {
            label: '备注',
            selected: false,
            default: false,
            fieldName: 'remark',
        },
        {
            label: '发票状态',
            selected: true,
            default: true,
            fieldName: 'invoiceStatus',
            type: 'dict',
            dict: 'ivat_invoice_status',
        },
        {
            label: '收票状态',
            selected: false,
            default: false,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            //20
            label: '抵扣属期',
            selected: true,
            default: true,
            fieldName: 'dkssq',
        },
        {
            label: '转出属期',
            selected: false,
            default: false,
            fieldName: 'zcssq',
        },
        {
            label: '转出类型',
            selected: false,
            default: false,
            fieldName: 'turnOutType',
            type: 'dict',
            dict: 'ivatRuleList',
        },
        {
            label: '业务单据号',
            selected: false,
            default: false,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: false,
            default: false,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: false,
            default: false,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: false,
            default: false,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 医疗费用收据 12
    12: [
        {
            label: '收据号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '姓名',
            selected: true,
            default: true,
            fieldName: 'userName',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
        },
        {
            label: '收票状态',
            selected: true,
            default: true,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '业务单据号',
            selected: true,
            default: true,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: true,
            default: true,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: true,
            default: true,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: true,
            default: true,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    // 教育费用收据 13
    13: [
        {
            label: '收据号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '姓名',
            selected: true,
            default: true,
            fieldName: 'userName',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
        },
        {
            label: '收票状态',
            selected: true,
            default: true,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            label: '业务单据号',
            selected: true,
            default: true,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //27
            label: '录入方式',
            selected: true,
            default: true,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            //9
            label: '人员/录入时间',
            selected: true,
            default: true,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: true,
            default: true,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    14: [
        {
            label: '票据种类',
            selected: true,
            default: true,
            fieldName: 'invoiceType',
            type: 'dict',
            dict: 'ivat_inv_type',
        },
        {
            label: '发票代码',
            selected: true,
            default: true,
            fieldName: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            fieldName: 'invoiceNumber',
        },
        {
            label: '数电票号码',
            selected: false,
            default: false,
            fieldName: 'electricInvoiceNum',
        },
        {
            label: '开票日期',
            selected: true,
            default: true,
            fieldName: 'invoiceDate',
        },
        {
            label: '销方名称',
            selected: true,
            default: true,
            fieldName: 'saleName',
        },
        {
            label: '销方税号',
            selected: false,
            default: false,
            fieldName: 'saleCreditCode',
        },
        {
            label: '销方地址电话',
            selected: false,
            default: false,
            fieldName: 'saleAddressPhone',
        },
        {
            label: '销方银行账号',
            selected: false,
            default: false,
            fieldName: 'saleBankAccount',
        },
        {
            label: '金额',
            selected: true,
            default: true,
            fieldName: 'totalAmt',
        },
        {
            label: '税率',
            selected: false,
            default: false,
            fieldName: 'taxRate',
            type: 'dict',
            dict: 'ovat_tax_rate',
        },
        {
            label: '税额',
            selected: true,
            default: true,
            fieldName: 'totalTaxamt',
        },
        {
            label: '价税合计',
            selected: true,
            default: true,
            fieldName: 'adValoremTotal',
        },
        {
            //13
            label: '购方名称',
            selected: false,
            default: false,
            fieldName: 'custName',
        },
        {
            //14
            label: '购方税号',
            selected: false,
            default: false,
            fieldName: 'custCreditCode',
        },
        {
            //15
            label: '购方地址电话',
            selected: false,
            default: false,
            fieldName: 'custAddressPhone',
        },
        {
            //16
            label: '购方银行账号',
            selected: false,
            default: false,
            fieldName: 'custBankAccount',
        },
        {
            //17
            label: '校验码',
            selected: false,
            default: false,
            fieldName: 'checkCode',
        },
        {
            //18
            label: '备注',
            selected: false,
            default: false,
            fieldName: 'remark',
        },
        {
            //19
            label: '发票状态',
            selected: true,
            default: true,
            fieldName: 'invoiceStatus',
            type: 'dict',
            dict: 'ivat_invoice_status',
        },
        {
            //20
            label: '收票状态',
            selected: false,
            default: false,
            fieldName: 'collectionStatus',
            type: 'dict',
            dict: 'is_received',
        },
        {
            //21
            label: '抵扣属期',
            selected: true,
            default: true,
            fieldName: 'dkssq',
        },
        {
            //22
            label: '转出属期',
            selected: false,
            default: false,
            fieldName: 'zcssq',
        },
        {
            //23
            label: '转出类型',
            selected: false,
            default: false,
            fieldName: 'turnOutType',
            type: 'dict',
            dict: 'ivatRuleList',
        },
        {
            //24
            label: '客运标志',
            selected: false,
            default: false,
            fieldName: 'passengerFlag',
            type: 'dict',
            dict: 'ivat_common_flag',
        },
        {
            //25
            label: '业务单据号',
            selected: false,
            default: false,
            fieldName: 'claimNumber',
        },
        {
            label: '项目名称',
            selected: false,
            default: false,
            fieldName: 'projectName',
        },
        {
            label: '项目编号',
            selected: false,
            default: false,
            fieldName: 'projectCode',
        },
        {
            //28
            label: '录入方式',
            selected: false,
            default: false,
            fieldName: 'billSource',
            type: 'dict',
            dict: 'ivat_bill_source',
        },
        {
            label: '人员/录入时间',
            selected: false,
            default: false,
            fieldName: ['realName', 'createTime'],
            type: 'manyValued',
        },
        {
            label: '收票人/时间',
            selected: false,
            default: false,
            fieldName: ['collectionPerson', 'collectionDate'],
            type: 'manyValued',
        },
        {
            label: '入账分类',
            selected: false,
            default: false,
            fieldName: 'rzflId',
            type: 'dict',
            dict: 'entryList',
        },
        {
            label: '进项转出标志',
            selected: false,
            default: false,
            fieldName: 'transferOutSign',
        },
        {
            label: '进项转出金额',
            selected: false,
            default: false,
            fieldName: 'transferAmount',
        },
        {
            label: '报销状态',
            selected: false,
            default: false,
            fieldName: 'reimbursementStatus',
            type: 'dict',
            dict: 'interface_invoice_status',
        },
        {
            label: '关联单据号',
            selected: false,
            default: false,
            fieldName: 'statementNumber',
        },
        {
            label: '凭证号',
            selected: false,
            default: false,
            fieldName: 'voucherNumber',
        },
        {
            label: '来源系统',
            selected: false,
            default: false,
            fieldName: 'sourceSystem',
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '管理分区',
            selected: false,
            default: false,
            fieldName: 'managementPartition',
        },
        {
            label: '流程申请人',
            selected: false,
            default: false,
            fieldName: 'processApplicant',
        },
        {
            label: '机构名称',
            selected: false,
            default: false,
            fieldName: 'orgId',
            type: 'fliterOrgName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            fieldName: 'departmentNo',
            type: 'dict',
            dict: 'department_no',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            fieldName: 'regionName',
            type: 'dict',
            dict: 'belleRegionList',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            fieldName: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            fieldName: 'province',
        },
        {
            label: '入账月份',
            selected: false,
            default: false,
            fieldName: 'paymentMonth',
        },
        {
            // 46
            label: '账套编码',
            selected: false,
            default: false,
            fieldName: 'accountSetCode',
        },
        {
            label: '是否修改',
            selected: false,
            default: false,
            fieldName: 'modifyStatus',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            fieldName: 'updateUser',
        },
        {
            label: '付款日期',
            selected: false,
            default: false,
            fieldName: 'paymentDate',
        },
        {
            label: '税局入账用途',
            selected: false,
            default: false,
            fieldName: 'entryPurposeStatus',
            type: 'dict',
            dict: 'entry_purpose_status',
        },
        {
            label: '税局入账日期',
            selected: false,
            default: false,
            fieldName: 'entryDate',
        },
        {
            label: '入账失败原因',
            selected: false,
            default: false,
            fieldName: 'entryFailDesc',
        },
        {
            label: '来源系统编码',
            selected: false,
            default: false,
            fieldName: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
}
const managementConfig = {
    version: 5.52,
    queryConfig: {
        splitBillFlag: true,
        commonField: [
            {
                label: '发票代码',
                selected: true,
                default: true,
            },
            {
                label: '发票号码',
                selected: true,
                default: true,
            },
            {
                label: '开票日期',
                selected: true,
                default: true,
            },
            {
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '价税合计',
                selected: true,
                default: true,
            },
            {
                label: '录入人员',
                selected: false,
                default: false,
            },

            {
                label: '录入方式',
                selected: false,
                default: false,
            },
            // { 优化隐藏
            //   label: '抵扣标志',
            //   selected: false,
            //   default: false,
            // },
            {
                label: '客运标志',
                selected: false,
                default: false,
            },
            {
                label: '业务单据号',
                selected: false,
                default: false,
            },
            {
                label: '收票状态',
                selected: false,
                default: false,
            },
            {
                label: '转出类型',
                selected: false,
                default: false,
            },
            {
                label: '转出属期',
                selected: false,
                default: false,
            },
            {
                label: '抵扣属期',
                selected: false,
                default: false,
            },
            {
                label: '录入时间',
                selected: true,
                default: true,
            },
            {
                label: '收票时间',
                selected: false,
                default: false,
            },
            {
                label: '项目名称',
                selected: false,
                default: false,
            },
            {
                label: '项目编号',
                selected: false,
                default: false,
            },
            {
                label: '进项转出标志',
                selected: false,
                default: false,
                fieldName: 'transferOutSign',
            },
            {
                label: '进项转出金额',
                selected: false,
                default: false,
                fieldName: 'transferAmount',
            },
            {
                label: '报销状态',
                selected: false,
                default: false,
                fieldName: 'reimbursementStatus',
            },
            {
                label: '关联单据号',
                selected: false,
                default: false,
                fieldName: 'statementNumber',
            },
            {
                label: '凭证号',
                selected: false,
                default: false,
                fieldName: 'voucherNumber',
            },
            {
                label: '来源系统',
                selected: false,
                default: false,
                fieldName: 'sourceSystem',
            },
            {
                label: '收票人',
                selected: false,
                default: false,
                fieldName: 'collectionPerson',
            },
            {
                label: '管理分区',
                selected: false,
                default: false,
                fieldName: 'managementPartition',
            },
            {
                label: '流程申请人',
                selected: false,
                default: false,
                fieldName: 'processApplicant',
            },
            {
                label: '机构名称',
                selected: false,
                default: false,
                fieldName: 'orgId',
            },
            {
                label: '事业部',
                selected: false,
                default: false,
                fieldName: 'departmentNo',
            },
            {
                label: '所属大区',
                selected: false,
                default: false,
                fieldName: 'regionName',
            },
            {
                label: '管理城市',
                selected: false,
                default: false,
                fieldName: 'cityName',
            },
            {
                label: '主管税局所在省市',
                selected: false,
                default: false,
                fieldName: 'province',
            },
            {
                label: '入账月份',
                selected: false,
                default: false,
                fieldName: 'paymentMonth',
            },
            {
                label: '是否修改',
                selected: false,
                default: false,
                fieldName: 'modifyStatus',
            },
            {
                label: '更新人',
                selected: false,
                default: false,
                fieldName: 'updateUser',
            },
            {
                label: '付款日期',
                selected: false,
                default: false,
                fieldName: 'paymentDate',
            },
            {
                label: '数电票号码',
                selected: false,
                default: false,
                fieldName: 'electricInvoiceNum',
            },
            {
                label: '来源系统编码',
                selected: false,
                default: false,
                fieldName: 'sourceAppId',
            },
        ],
        valueAddedTaxField: [
            {
                label: '票据种类',
                selected: false,
                default: false,
            },
            {
                label: '销方名称',
                selected: false,
                default: false,
            },
            {
                label: '销方税号',
                selected: false,
                default: false,
            },
            {
                label: '发票状态',
                selected: false,
                default: false,
            },
            {
                label: '状态比对',
                selected: false,
                default: false,
            },
            {
                label: '入账用途',
                selected: false,
                default: false,
            },
            {
                label: '来源系统编码',
                selected: false,
                default: false,
                fieldName: 'sourceAppId',
            },
        ],
        otherInvoiceField: [
            {
                label: '姓名',
                selected: false,
                default: false,
            },
            {
                label: '目的地',
                selected: false,
                default: false,
            },
            {
                label: '出发地',
                selected: false,
                default: false,
            },
            {
                label: '来源系统编码',
                selected: false,
                default: false,
                fieldName: 'sourceAppId',
            },
        ],
    },
    allTable: managementTableConfig,
    table: [],
    billTypeSet: [
        {
            type: 1,
            label: '增值税发票',
        },
        {
            type: 2,
            label: '通用机打发票',
        },
        {
            type: 3,
            label: '航空运输电子客票行程单',
        },
        {
            type: 4,
            label: '铁路车票',
        },
        {
            type: 5,
            label: '公路、水路客票',
        },
        {
            type: 6,
            label: '出租车发票',
        },
        {
            type: 7,
            label: '过桥、路费发票',
        },
        {
            type: 8,
            label: '通用定额发票',
        },
        {
            type: 9,
            label: '停车费发票',
        },
        {
            type: 10,
            label: '机动车销售统一发票',
        },
        {
            type: 11,
            label: '二手车销售统一发票',
        },
        {
            type: 12,
            label: '医疗费用收据',
        },
        {
            type: 13,
            label: '教育费用收据',
        },
        {
            type: 14,
            label: '区块链电子发票',
        },
    ],
    billParamSet: {
        1: {
            invoiceTypeList: [],
            profileType: 107,
        },
        2: {
            invoiceTypeList: [107],
            profileType: 115,
        },
        3: {
            invoiceTypeList: [102],
            profileType: 109,
        },
        4: {
            invoiceTypeList: [103],
            profileType: 110,
        },
        5: {
            invoiceTypeList: [104],
            profileType: 111,
        },
        6: {
            invoiceTypeList: [106],
            profileType: 112,
        },
        7: {
            invoiceTypeList: [101],
            profileType: 114,
        },
        8: {
            invoiceTypeList: [105],
            profileType: 108,
        },
        9: {
            invoiceTypeList: [108],
            profileType: 113,
        },
        10: {
            invoiceTypeList: [12],
            profileType: 119,
        },
        11: {
            invoiceTypeList: [15],
            profileType: 118,
        },
        12: {
            invoiceTypeList: [109],
            profileType: 116,
        },
        13: {
            invoiceTypeList: [110],
            profileType: 117,
        },
        14: {
            invoiceTypeList: [111],
            profileType: 111,
        },
    },
}
export default managementConfig



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/management/fieldConfig.js